import myFiSwapSuggestionActions from "../../../actions/myFiSwapSuggestionActions";
import myFiSwapSuggestionTableColumns, {
  myFiSwapSuggestionTableLeftFixedColumns,
} from "./myFiSwapSuggestionTableColumns";
import generateEntityTable from "../../../hocs/generateEntityTable";

const MyFiSwapSuggestionsTable = generateEntityTable({
  entityPluralString: "myFiSwapSuggestions",
  entityActions: myFiSwapSuggestionActions,
  columns: myFiSwapSuggestionTableColumns,
  leftFixedColumns: myFiSwapSuggestionTableLeftFixedColumns,
  // operations: [],
  copyFiSwapSuggestionTextOperation: true,
});

export default MyFiSwapSuggestionsTable;
